<template>
  <div class="pt-16">
    <div class="height-full bg-FFFFFF bd-radio-8 m-0-12 p-0-16 scroll">
      <p class="text-bold font-38 mt-16">操作指引</p>
      <p class="font-34 mt-12">1、找到对应孩子，复制家长ID</p>
      <p class="font-34 mt-12 fb fb-cross-start"
        ><span>2、</span
        ><span>家长打开学校微信公众号，找到并点击智慧校园</span></p
      >
      <p class="font-34 mt-12">3、填写家长ID，完成绑定</p>
      <p class="text-bold font-38 mt-24">学生信息表</p>
      <div class="table font-32 mt-12 mb-16">
        <div class="table-head fb fb-main-start items-center font-30">
          <p class="bb-grid br-grid w-p-22 p-8-0 p-0-8">班级</p>
          <p class="bb-grid br-grid w-p-20 p-8-0 p-0-8">学生</p>
          <p class="bb-grid br-grid w-p-17 p-8-0 p-0-8">家长</p>
          <p class="bb-grid w-p-41 p-8-0 p-0-8">家长ID</p>
        </div>
        <div
          class="table-body fb fb-main-start items-center font-28"
          v-for="(item, index) in datas"
          :key="item.shortCode"
        >
          <p
            class="br-grid w-p-22 p-8-0 p-0-8"
            :class="{
              'bb-grid': index < datas.length - 1
            }"
            >{{ item.classShortName }}</p
          >
          <p
            class="br-grid w-p-20 p-8-0 p-0-8"
            :class="{
              'bb-grid': index < datas.length - 1
            }"
            >{{ item.studentName }}</p
          >
          <p
            class="br-grid w-p-17 p-8-0 p-0-8"
            :class="{
              'bb-grid': index < datas.length - 1
            }"
            >{{ item.relation }}</p
          >
          <p
            class="w-p-41 p-8-0 p-0-8 break-word"
            :class="{
              'bb-grid': index < datas.length - 1
            }"
            >{{ item.shortCode
            }}<i
              class="iconfont c-006AFE ml-4"
              @click="() => handlerCopy(item.shortCode)"
              >&#xe6c5;</i
            ></p
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import { copyText } from '@/utils/comUtils'
import { mcToast } from '@/utils/mcSdkUtils'
export default {
  name: 'PageWechatGuideIdList',
  data() {
    return {
      datas: [],
      classId: this.$route.query.classId
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      API.getGuardianCode({
        classId: this.classId,
        orgId: this.$route.query.orgId
      })
        .then(res => {
          if (res && res.result && res.result !== '0') {
            mcToast({
              msg: res.message
            })
          } else {
            this.datas = res
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    handlerCopy(shortCode) {
      copyText(shortCode)
      mcToast({ msg: '复制成功' })
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  border: 1px solid #000;
}
.bb-grid {
  border-bottom: 1px solid #000;
}
.br-grid {
  border-right: 1px solid #000;
}
.break-word{
  word-break: break-all;
}
</style>
